/* eslint-disable */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { assetImages } from "constants";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, putData } from "utils/Gateway";
import { getConvertedDateText } from "helper/EventHelper/EventHelper";
import MyMeetingFilterPopup from "../Popup/MyMeetingFilterPopup";
import FeedbackSuccessModal from "Components/Common/Modals/FeedbackSuccessModal";
import ReviewFeedbackModal from "Components/Common/Modals/ReviewFeedbackModal";

const MyMeetingList = ({ eventId, showTitle }) => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const todayValue = new Date().toISOString().split("T")[0];

  const glowCount = [1, 2, 3];

  const [isLoading, setIsLoading] = useState(false);
  const [agendaList, setAgendaList] = useState([]);

  const [filterAgendaDate, setfilterAgendaDate] = useState("");
  const [filterMeetingType, setfilterMeetingType] = useState("");
  const [filterMeetingTitle, setfilterMeetingTitle] = useState("");
  const [filterSentList, setfilterSentList] = useState(false);
  const [filterRecieveList, setfilterRecieveList] = useState(false);
  const [filterPendingList, setfilterPendingList] = useState(false);
  const [filterAcceptList, setfilterAcceptList] = useState(false);
  const [filterTodayList, setfilterTodayList] = useState(false);
  const [filterUpcomingList, setfilterUpcomingList] = useState(false);
  const [filterPastList, setfilterPastList] = useState(false);

  const [reviewType, setReviewType] = useState("");
  const [feedbackAgendaId, setfeedbackAgendaId] = useState(null);
  const [userFeedbackMeetingReason, setUserFeedbackMeetingReason] =
    useState("");

  //function for get all event members
  const getAllMyMeetings = async () => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_MY_MEETINGS + `?token=${token}`;

      if (filterAgendaDate != "") {
        requestUrl += `&filterdates=${filterAgendaDate}`;
      }

      if (filterMeetingTitle != "") {
        requestUrl += `&filterdescription=${filterMeetingTitle}`;
      }

      if (filterMeetingType != "") {
        requestUrl += `&filtermeetingtype=${filterMeetingType}`;
      }

      if (filterSentList) {
        requestUrl += `&filtersentlist=${filterSentList}`;
      }

      if (filterRecieveList) {
        requestUrl += `&filterrecievelist=${filterRecieveList}`;
      }

      if (filterPendingList) {
        requestUrl += `&filterpendinglist=${filterPendingList}`;
      }

      if (filterAcceptList) {
        requestUrl += `&filteracceptlist=${filterAcceptList}`;
      }

      if (filterTodayList) {
        requestUrl += `&filtertodaylist=${filterTodayList}`;
      }

      if (filterUpcomingList) {
        requestUrl += `&filterupcominglist=${filterUpcomingList}`;
      }

      if (filterPastList) {
        requestUrl += `&filterpastlist=${filterPastList}`;
      }

      const response = await getData(requestUrl);

      setIsLoading(false);

      console.log(response);

      if (response.status) {
        resetFilter();
        setAgendaList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //accept/reject
  const meetingActionHandler = async (agendaData, action) => {
    try {
      let agendaDataUpdated = {
        senderuser: agendaData.userid?._id,
        meetinguser: agendaData.meetinguserid?._id,
        meetingdate: agendaData.date,
        starttime: agendaData.starttime,
        endtime: agendaData.endtime,
        action,
      };

      // console.log(agendaDataUpdated);

      let requestUrl =
        url.API_BASE_URL +
        url.API_ACCPET_REJECT_MEETING +
        `/${agendaData._id}?token=${token}`;

      const response = await putData(requestUrl, agendaDataUpdated);

      console.log(response);
      getAllMyMeetings();
    } catch (error) {
      console.log(error.message);
    }
  };

  const resetFilter = () => {
    setfilterAgendaDate("");
    setfilterMeetingTitle("");
    setfilterMeetingType("");
    setfilterSentList(false);
    setfilterRecieveList(false);
    setfilterPendingList(false);
    setfilterAcceptList(false);
    setfilterTodayList(false);
    setfilterUpcomingList(false);
    setfilterPastList(false);
  };

  const refreshHandler = () => {
    getAllMyMeetings();
  };

  useEffect(() => {
    if (
      filterAgendaDate != "" ||
      filterMeetingTitle != "" ||
      filterMeetingType != "" ||
      filterSentList ||
      filterRecieveList ||
      filterPendingList ||
      filterAcceptList ||
      filterTodayList ||
      filterUpcomingList ||
      filterPastList
    ) {
      getAllMyMeetings();
    }
  }, [
    filterAgendaDate,
    filterMeetingTitle,
    filterMeetingType,
    filterSentList,
    filterRecieveList,
    filterPendingList,
    filterAcceptList,
    filterTodayList,
    filterUpcomingList,
    filterPastList,
  ]);

  useEffect(() => {
    getAllMyMeetings();
  }, []);

  return (
    <>
      <div
        className={`page_heading  d-flex align-items-center flex-wrap gap-3 ${
          showTitle ? "justify-content-between mb-5" : "justify-content-end"
        }`}
      >
        {showTitle && (
          <h1 className="position-relative pb-4 text-uppercase">My meetings</h1>
        )}

        <div className="d-flex align-items-center">
          <Link
            to="#"
            className="filter_btn d-flex align-items-center justify-content-center bg_primary me-2"
            onClick={refreshHandler}
          >
            <span className="material-icons-outlined text-white">refresh</span>
          </Link>
          <Link
            to="#"
            className="filter_btn d-flex align-items-center justify-content-center bg_primary"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasMyMeetings"
          >
            <span className="material-icons-outlined text-white">
              filter_list
            </span>
          </Link>
        </div>
      </div>

      <div className="meet_bx_outer">
        {isLoading ? (
          glowCount.map((count, index) => {
            return (
              <div className="meet_row bg_white p-4 d-flex mb-3" key={index}>
                <div className="meet_time_left">
                  <h3
                    className="d-flex align-items-center gap-2 mb-2 placeholder placeholder-sm"
                    style={{ width: "50%" }}
                  ></h3>
                  <h5
                    className="d-flex align-items-center gap-2 placeholder placeholder-sm"
                    style={{ width: "35%" }}
                  ></h5>
                  <span
                    className="btn primary-btn placeholder mt-3"
                    style={{ width: "140px", height: "50px" }}
                  ></span>
                </div>
                <div className="meet_time_right">
                  <h3 className="text-uppercase fs-xl text-primary mb-3">
                    <i
                      className="placeholder placeholder-sm"
                      style={{ width: "15%" }}
                    ></i>
                  </h3>
                  <h3 className="text-uppercase fs-xl text-primary mb-3">
                    <span
                      className="d-inline-block fs-sm fw-medium placeholder placeholder-sm"
                      style={{ width: "35%", height: "25px" }}
                    ></span>
                  </h3>

                  <p>
                    <span className="d-block fs-sm text-primary-gray fw-medium placeholder placeholder-sm mb-3"></span>
                    <span className="d-block fs-sm text-primary-gray fw-medium placeholder placeholder-sm mb-3"></span>
                    <span className="d-block fs-sm text-primary-gray fw-medium placeholder placeholder-sm mb-3"></span>
                    <span className="d-block fs-sm text-primary-gray fw-medium placeholder placeholder-sm mb-3"></span>
                    <span className="d-block fs-sm text-primary-gray fw-medium placeholder placeholder-sm mb-3"></span>
                    <span className="d-block fs-sm text-primary-gray fw-medium placeholder placeholder-sm mb-3"></span>
                  </p>
                  <div className="meet_btns d-flex align-items-center gap-2 mt-3">
                    {/* <Link to="#" className="btn primary-btn">
                Accept
              </Link> */}
                  </div>
                </div>
              </div>
            );
          })
        ) : agendaList.length > 0 ? (
          agendaList.map((agendaData, index) => {
            return (
              <div className="meet_row bg_white p-4 d-flex mb-3" key={index}>
                {agendaData.eventid ? (
                  <>
                    {/* event agenda */}
                    <div className="meet_time_left">
                      <h3 className="d-flex align-items-center gap-2 mb-2">
                        <i className="material-icons-outlined text-pink fs-md">
                          schedule
                        </i>
                        <span className="fs-lg fw-bold text-primary">
                          {agendaData.starttime} - {agendaData.endtime}
                        </span>
                      </h3>
                      <h5 className="d-flex align-items-center gap-2">
                        <i className="material-icons-outlined fs-md text-primary-gray">
                          event_note
                        </i>
                        <span className="text-primary-gray fs-sm">
                          {agendaData.date}
                        </span>
                      </h5>
                      {agendaData.date > todayValue ? null : (
                        <div className="meet_btns d-flex align-items-center gap-2 mt-3">
                          <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#feedback_modal"
                            className="btn outline"
                            onClick={() => {
                              setfeedbackAgendaId(agendaData._id);
                              setUserFeedbackMeetingReason("");
                              setReviewType("event");
                            }}
                          >
                            Feedback
                          </Link>
                        </div>
                      )}
                    </div>
                    <div className="meet_time_right">
                      <h3 className="text-uppercase fs-xl text-primary d-flex align-items-center gap-2 mb-3">
                        {agendaData.description}
                      </h3>
                      <div className="meeting_info_outer mb-4">
                        <ul className="d-flex align-items-center gap-2 list_style_none">
                          <li className="d-inline-flex align-items-center rounded-90 fs-sm text-pink fw-medium round-gray-border px-2 py-1 gap-1">
                            <i className="material-icons-outlined fs-md">
                              timer
                            </i>
                            {agendaData.duration}
                          </li>
                          <li className="d-inline-flex align-items-center rounded-90 fs-sm text-primary-gray fw-medium round-gray-border px-2 py-1 gap-1">
                            <i className="material-icons-outlined text-primary-gray fs-md">
                              my_location
                            </i>
                            <span> {agendaData.location}</span>
                          </li>
                          <li className=" d-flex align-items-center">
                            {agendaData.attandantsarr.map((member, index) => {
                              return (
                                <span
                                  className="usr_img d-block rounded-circle overflow-hidden"
                                  style={{
                                    height: "26px",
                                    width: "26px",
                                    minWidth: "26px",
                                  }}
                                  key={index}
                                >
                                  <img
                                    src={
                                      member.image == ""
                                        ? assetImages.defaultUser
                                        : url.SERVER_URL + member.image
                                    }
                                    alt=""
                                  />
                                </span>
                              );
                            })}
                          </li>
                        </ul>
                      </div>

                      <div className="agenda_info_btn bg-pink rounded-40 px-3 py-2 mt-3 d-inline-block">
                        <span className="d-block text-center text-white fw-medium fs-sm position-relative">
                          {agendaData.eventname}
                        </span>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {/* user agenda */}
                    <div className="meet_time_left">
                      <h3 className="d-flex align-items-center gap-2 mb-2">
                        <i className="material-icons-outlined text-pink fs-md">
                          schedule
                        </i>
                        <span className="fs-lg fw-bold text-primary">
                          {agendaData.starttime} - {agendaData.endtime}
                        </span>
                      </h3>
                      <h5 className="d-flex align-items-center gap-2">
                        <i className="material-icons-outlined fs-md text-primary-gray">
                          event_note
                        </i>
                        <span className="text-primary-gray fs-sm">
                          {agendaData.date}
                        </span>
                      </h5>
                      {agendaData.meetingstate == "1" ? (
                        <div className="meet_btns d-flex align-items-center gap-2 mt-3">
                          <Link to="#" className="btn disabled">
                            Accepted
                          </Link>
                          {agendaData.date > todayValue ? null : (
                            <Link
                              to="#"
                              className="btn outline"
                              data-bs-toggle="modal"
                              data-bs-target="#feedback_modal"
                              onClick={() => {
                                setReviewType("user");
                                setfeedbackAgendaId(agendaData._id);
                                setUserFeedbackMeetingReason(
                                  agendaData.meetingreason
                                );
                              }}
                            >
                              Feedback
                            </Link>
                          )}
                        </div>
                      ) : agendaData.issent ? (
                        <div className="meet_btns d-flex align-items-center gap-2 mt-3">
                          <Link to="#" className="btn disabled">
                            Awaiting Response
                          </Link>
                          <Link
                            to="#"
                            className="btn outline"
                            onClick={() => {
                              meetingActionHandler(agendaData, "2");
                            }}
                          >
                            Cancel Request
                          </Link>
                        </div>
                      ) : (
                        <div className="meet_btns d-flex align-items-center gap-2 mt-3">
                          <Link
                            to="#"
                            className="btn primary-btn"
                            onClick={() => {
                              meetingActionHandler(agendaData, "1");
                            }}
                          >
                            Accept
                          </Link>
                          <Link
                            to="#"
                            className="btn"
                            onClick={() => {
                              meetingActionHandler(agendaData, "2");
                            }}
                          >
                            Reject
                          </Link>
                        </div>
                      )}
                    </div>
                    <div className="meet_time_right">
                      <h3 className="text-uppercase fs-xl text-primary d-flex align-items-center gap-2 mb-3">
                        {agendaData.description}
                      </h3>
                      <div className="meeting_info_outer mb-4">
                        <ul className="d-flex align-items-center gap-2 list_style_none">
                          <li className="d-inline-flex align-items-center rounded-90 fs-sm text-pink fw-medium round-gray-border px-2 py-1 gap-1">
                            <i className="material-icons-outlined fs-md">
                              timer
                            </i>
                            {agendaData.duration}
                          </li>
                          <li className="d-inline-flex align-items-center rounded-90 fs-sm text-primary-gray fw-medium round-gray-border px-2 py-1 gap-1">
                            <i className="material-icons-outlined text-primary-gray fs-md">
                              my_location
                            </i>
                            <span>{agendaData.location}</span>
                          </li>
                          <li className=" d-flex align-items-center">
                            <span
                              className="usr_img d-block rounded-circle overflow-hidden"
                              style={{
                                height: "26px",
                                width: "26px",
                                minWidth: "26px",
                              }}
                            >
                              <img
                                src={
                                  url.SERVER_URL +
                                  agendaData?.meetinguserid?.photoimage?.path
                                }
                                alt=""
                              />
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div className="meet_info_outer d-flex flex-wrap align-items-center">
                        <div className="left_meet_info text-center">
                          <div className="speaker_pic rounded-circle overflow-hidden mb-3">
                            <img
                              src={
                                agendaData.meetinguserimage == ""
                                  ? assetImages.defaultUser
                                  : url.SERVER_URL + agendaData.meetinguserimage
                              }
                              alt=""
                            />
                          </div>
                          <div className="speaker_info">
                            <h4 className="mb-2 fs-lg fw-semibold text-primary">
                              {agendaData?.meetingusername}
                            </h4>
                            <h6 className="fs-sm text-primary">
                              <span className="d-block">
                                {agendaData.meetingusercity} -{" "}
                                {agendaData.meetingusercountry}
                              </span>{" "}
                            </h6>
                          </div>
                        </div>
                        <div className="meeting_bx text-center">
                          <h5 className="text-primary fs-sm mb-1 fw-bold">
                            {agendaData?.meetingusername}
                          </h5>
                          <h4 className="text-primary fs-xl mb-3 fw-bold">
                            {agendaData.duration} Minute Meeting
                          </h4>
                          <h5 className="d-flex align-items-center gap-2 mb-3 justify-content-center">
                            <i className="material-icons-outlined text-pink fs-sm">
                              calendar_month
                            </i>
                            <span className="fs-sm fw-bold text-primary">
                              {agendaData.starttime} - {agendaData.endtime},{" "}
                              {getConvertedDateText(agendaData.date)}
                            </span>
                          </h5>
                          <h5 className="d-flex align-items-center gap-2 justify-content-center">
                            <i className="material-icons-outlined text-pink fs-sm">
                              language
                            </i>
                            <span className="fs-sm fw-bold text-primary">
                              India Standard Time
                            </span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            );
          })
        ) : (
          <div className="no_events text-center">
            <span className="d-block text-center mb-2">
              <img src={assetImages.handShake} alt="" />
            </span>
            <h5 className="text-primary fs-sm ">No meetings to show</h5>
          </div>
        )}

        <MyMeetingFilterPopup
          setfilterMeetingTitle={setfilterMeetingTitle}
          setfilterMeetingType={setfilterMeetingType}
          setfilterAgendaDate={setfilterAgendaDate}
          setfilterSentList={setfilterSentList}
          setfilterRecieveList={setfilterRecieveList}
          setfilterPendingList={setfilterPendingList}
          setfilterAcceptList={setfilterAcceptList}
          setfilterTodayList={setfilterTodayList}
          setfilterUpcomingList={setfilterUpcomingList}
          setfilterPastList={setfilterPastList}
        />

        <ReviewFeedbackModal
          moduleId={feedbackAgendaId}
          moduleName={"agenda"}
          reviewType={reviewType}
          meetingReason={userFeedbackMeetingReason}
          onModalClose={() => {
            setfeedbackAgendaId(null);
            setUserFeedbackMeetingReason("");
            setReviewType("");
          }}
        />

        <FeedbackSuccessModal
          onModalClose={() => {
            setfeedbackAgendaId(null);
          }}
        />
      </div>
    </>
  );
};

export default MyMeetingList;
